import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'اقتباس',
  },
  az: {
    label: 'Blokkvota',
  },
  bg: {
    label: 'Цитат',
  },
  cs: {
    label: 'Citace',
  },
  da: {
    label: 'Blokering',
  },
  de: {
    label: 'Blockzitat',
  },
  en: {
    label: 'Blockquote',
  },
  es: {
    label: 'Cita en bloque',
  },
  et: {
    label: 'Tsitaat',
  },
  fa: {
    label: 'نقل قول بلوکی',
  },
  fr: {
    label: 'Citation',
  },
  he: {
    label: 'בלוק ציטוט',
  },
  hr: {
    label: 'Blok citat',
  },
  hu: {
    label: 'Idézetblokk',
  },
  is: {
    label: 'Tilvitnun',
  },
  it: {
    label: 'Citazione',
  },
  ja: {
    label: 'ブロッククォート',
  },
  ko: {
    label: '인용구',
  },
  my: {
    label: 'ဒေါင်းချီးခြင်း',
  },
  nb: {
    label: 'Blokksitat',
  },
  nl: {
    label: 'Citaat',
  },
  pl: {
    label: 'Cytat blokowy',
  },
  pt: {
    label: 'Citação em bloco',
  },
  ro: {
    label: 'Citat',
  },
  rs: {
    label: 'Блок цитата',
  },
  'rs-latin': {
    label: 'Blok citata',
  },
  ru: {
    label: 'Цитата',
  },
  sk: {
    label: 'Citát',
  },
  sl: {
    label: 'Citat',
  },
  sv: {
    label: 'Blockcitat',
  },
  ta: {
    label: 'கட்டமைப்பு மேற்கோள்',
  },
  th: {
    label: 'ข้อความอ้างอิง',
  },
  tr: {
    label: 'Alıntı',
  },
  uk: {
    label: 'Блокцитата',
  },
  vi: {
    label: 'Trích dẫn',
  },
  zh: {
    label: '引用区块',
  },
  'zh-TW': {
    label: '引用塊',
  },
}
